<header id="ebo-top-header" [ngClass]="{'blurred': drawer.opened}">
  <div class="logo-va">
    <a [routerLink]="[hasEnvironmentPermission ? '/test/dashboard/view' : '/prod/dashboard/view']">
      <img alt="EBO" class="topbar-logo" [src]="(logoSrc$ | async)" />
    </a>

    <ng-container *appHasPermission="'select-agent.view'">
      <ebo-dropdown
        *ngIf="((botOptions$ | async)?.length > 0 && hideVASelector == false) && (isBotCreated$ | async)"
        [title]="'Virtual Agent'"
        [options]="botOptions$ | async"
        [value]="selectedBotId$ | async"
        (selectionChange)="setBot($event)"
        [placeholder]="'Select a Virtual Agent'"
      >
      </ebo-dropdown>
    </ng-container>

    <ng-container *ngIf="hasEnvironmentPermission; else noPermission">
      <div *ngIf="(isBotCreated$ | async)" class="environments">
        <mat-button-toggle-group
          #group="matButtonToggleGroup"
          (change)="setEnvironment(group.value)"
          [value]="(environment$ | async)"
          class="toggle-buttons"
        >
          <mat-button-toggle id="env-production" value="Prod">
            <ng-container *ngIf="tablet; else iconProd">
              <span>Production</span>
            </ng-container>
            <ng-template #iconProd>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path
                    d="M9.28195 8.21631L19.4634 14.0948L9.28195 19.9732V8.21694M9.06844 6.60488C8.42286 6.60488 7.83034 7.1216 7.83034 7.84298V20.3453C7.83034 21.0673 8.42286 21.5834 9.06844 21.5834C9.27437 21.5834 9.48536 21.5309 9.68497 21.416L20.5127 15.1648C21.337 14.6892 21.337 13.4991 20.5127 13.0234L9.68497 6.77228C9.48599 6.65731 9.27437 6.60488 9.06844 6.60488Z"
                    fill="currentColor"
                  />
                  <path
                    d="M14 1.45161C15.6948 1.45161 17.3378 1.78324 18.8835 2.43703C20.3775 3.06872 21.7198 3.97392 22.8726 5.12674C24.0254 6.27956 24.9306 7.62189 25.5623 9.11582C26.2161 10.6622 26.5478 12.3052 26.5478 14C26.5478 15.6948 26.2161 17.3378 25.5623 18.8842C24.9306 20.3781 24.0254 21.7204 22.8726 22.8733C21.7198 24.0261 20.3775 24.9313 18.8835 25.563C17.3372 26.2168 15.6942 26.5484 14 26.5484C12.3058 26.5484 10.6622 26.2168 9.11582 25.563C7.62189 24.9313 6.27956 24.0261 5.12674 22.8733C3.97392 21.7204 3.06872 20.3781 2.43703 18.8842C1.78324 17.3378 1.45161 15.6948 1.45161 14C1.45161 12.3052 1.78324 10.6622 2.43703 9.11582C3.06872 7.62189 3.97392 6.27956 5.12674 5.12674C6.27956 3.97392 7.62189 3.06872 9.11582 2.43703C10.6622 1.78324 12.3052 1.45161 14 1.45161ZM14 0C6.26819 0 0 6.26819 0 14C0 21.7318 6.26819 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26819 21.7318 0 14 0Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </ng-template>
          </mat-button-toggle>
          <mat-button-toggle id="env-test" value="Test">
            <ng-container *ngIf="tablet; else iconTest">
              <span>Test</span>
            </ng-container>
            <ng-template #iconTest>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28" fill="none">
                  <path
                    d="M24.9678 21.7308C24.4773 20.8674 16.9489 9.79028 16.8725 9.67869L16.8373 9.62641L16.8332 2.47738L18.5958 0.0751788C18.5588 0.0463994 18.5171 0.0187947 18.4906 0.00939735L13.0966 0.010572L8.79081 0L8.78729 9.62641L8.75146 9.67869C8.67569 9.79028 1.14665 20.8674 0.656226 21.7308C-0.201282 23.242 -0.312288 25.68 0.889986 26.8999C1.55485 27.5748 2.57211 27.9859 3.61169 28H22.0141C23.0507 27.9859 24.0686 27.5748 24.7328 26.8999C25.7037 25.915 26.0291 23.6026 24.9666 21.7308H24.9678ZM2.96739 20.8745L10.2427 10.0094L10.2527 1.36027H15.3719L15.3819 10.0094L22.6572 20.8745H2.96739Z"
                    fill="currentColor"
                  />
                  <path
                    d="M10.6515 19.0555C9.37051 19.0555 8.32858 18.0135 8.32858 16.7326C8.32858 15.4516 9.37051 14.4097 10.6515 14.4097C11.9325 14.4097 12.9744 15.4516 12.9744 16.7326C12.9744 18.0135 11.9325 19.0555 10.6515 19.0555ZM10.6515 15.4675C9.95373 15.4675 9.38578 16.0354 9.38578 16.7332C9.38578 17.4309 9.95373 17.9989 10.6515 17.9989C11.3492 17.9989 11.9172 17.4309 11.9172 16.7332C11.9172 16.0354 11.3492 15.4675 10.6515 15.4675Z"
                    fill="currentColor"
                  />
                  <path
                    d="M13.4707 13.9621C12.5298 13.9621 11.7639 13.1962 11.7639 12.2553C11.7639 11.3144 12.5298 10.5485 13.4707 10.5485C14.4116 10.5485 15.1775 11.3144 15.1775 12.2553C15.1775 13.1962 14.4116 13.9621 13.4707 13.9621ZM13.4707 11.4295C13.0155 11.4295 12.6449 11.8001 12.6449 12.2553C12.6449 12.7105 13.0155 13.0811 13.4707 13.0811C13.9259 13.0811 14.2965 12.7105 14.2965 12.2553C14.2965 11.8001 13.9259 11.4295 13.4707 11.4295Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </ng-template>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-container>

    <ng-template #noPermission>
      <div *ngIf="(isBotCreated$ | async)" class="environments">
        <mat-button-toggle-group #group="matButtonToggleGroup" class="toggle-buttons" value="Prod">
          <mat-button-toggle value="Prod">
            <span>Production</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-template>
  </div>
  <div class="ebo-icons">
    <div class="network">
      <ng-container *ngIf="!hubStatus && (isBotCreated$ | async); else noConnection">
        <button class="w-rounded" mat-icon-button>
          <mat-icon aria-hidden="false" aria-label="Network On" svgIcon="network_on"></mat-icon>
        </button>
      </ng-container>
      <ng-template #noConnection>
        <button class="w-rounded" mat-icon-button>
          <mat-icon
            aria-hidden="false"
            aria-label="Network Off"
            svgIcon="network_off"
            color="warn"
            matTooltip="Network connection lost. Some features may not work properly."
            matTooltipPosition="below"
          ></mat-icon>
        </button>
      </ng-template>
    </div>

    <div class="notifications">
      <ebo-notifications></ebo-notifications>
    </div>

    <ng-container *appHasPermission="'settings.view'">
      <button (click)="settings()" *ngIf="(isBotCreated$ | async)" class="settings w-rounded" mat-icon-button>
        <mat-icon aria-hidden="false" aria-label="Settings" svgIcon="settings"></mat-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="!tablet; else desktopMenu">
      <button mat-icon-button (click)="drawer.toggle()" aria-label="Side menu" class="mobile-menu drawer-toggle-btn">
        <mat-icon aria-hidden="false" aria-label="Menu" svgIcon="dots"></mat-icon>
      </button>
    </ng-container>

    <ng-template #desktopMenu>
      <ng-container>
        <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="account">
          <ngx-avatars size="40" [src]="(picture$ | async)" [name]="(fullName$ | async)"></ngx-avatars>
        </button>
        <mat-menu #accountMenu="matMenu">
          <ng-container *ngIf="!(isAzure$ | async)">
            <button id="reset-password" mat-menu-item (click)="resetOurPassword()">
              <!-- TODO: Replace Icon with SVG from Figma  -->
              <mat-icon>lock</mat-icon>
              <span>Reset password</span>
            </button>
          </ng-container>
          <button id="signout" mat-menu-item (click)="signOut()">
            <!-- TODO: Replace Icon with SVG from Figma  -->
            <mat-icon>exit_to_app</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </ng-container>
    </ng-template>

    <!--    <mat-menu #menu="matMenu" xPosition="before">-->
    <!--      <button-->
    <!--        mat-menu-item-->
    <!--        class="icon"-->
    <!--        *ngFor="let item of menuItems;"-->
    <!--        [class.active]="isActiveRoute(item)"-->
    <!--        (click)="navigateTo(item.state)"-->
    <!--      >-->
    <!--        <mat-icon [svgIcon]="item.svgIcon" aria-hidden="false"></mat-icon>-->
    <!--        <span class="name"> {{item.name}} </span>-->
    <!--      </button>-->
    <!--      <mat-divider></mat-divider>-->
    <!--      <ng-container *ngIf="!(isAzure$ | async)">-->
    <!--        <button (click)="resetOurPassword()" id="reset-password" mat-menu-item>-->
    <!--          <mat-icon>lock</mat-icon>-->
    <!--          <span>Reset password</span>-->
    <!--        </button>-->
    <!--      </ng-container>-->
    <!--      <button (click)="signOut()" id="signout" mat-menu-item>-->
    <!--        <mat-icon>exit_to_app</mat-icon>-->
    <!--        <span>Sign out</span>-->
    <!--      </button>-->
    <!--    </mat-menu>-->
  </div>
</header>
